import "@/App.css";
import LoadingScreen from "./components/LoadingScreen";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Rooms from "./components/Rooms";
import Gallery from "./components/Gallery";
import Facilities from "./components/Facilities";
import Footer from "./components/Footer";
import WaveDivider from "./components/WaveDivider";
import { LanguageProvider } from "./i18n/LanguageContext";

function App() {
  return (
    <LanguageProvider>
      <div className="App" data-testid="app-root">
        <LoadingScreen />
        <Navbar />
        <main>
          <Hero />
          <WaveDivider color="#00FF66" opacity={0.25} />
          <About />
          <WaveDivider flip color="#00FF66" opacity={0.2} />
          <Rooms />
          <WaveDivider color="#00FF66" opacity={0.25} />
          <Gallery />
          <WaveDivider flip color="#00FF66" opacity={0.2} />
          <Facilities />
        </main>
        <Footer />
      </div>
    </LanguageProvider>
  );
}

export default App;
